import { Typography } from "@shared/ui/Typography";
import React from "react";
import styled from "styled-components";
import { Calculator } from "@features/Calculator";
import { motion } from "framer-motion";
import { useTranslation } from "next-i18next";
import { routePaths } from "@shared/routes";

interface IProps {
  initSum: number;
  minSum: number;
  maxSum: number;
  stepSum: number;
  fromSum: string;
  toSum: string;

  initTerm: number;
  minTerm: number;
  maxTerm: number;
  stepTerm: number;
  fromTerm: string;
  toTerm: string;

  href: string;
  openContactModal?: () => void;
  productId?: number;
  rate?: number;
}

export default function ProductCalculator(props: IProps) {
  const { t } = useTranslation();

  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 10 }}
      transition={{ duration: 0.2 }}
    >
      <StyledTitle tag="h2" fontSize="4rem" weight={700}>
        {t(`Калькулятор`)}
      </StyledTitle>
      <Calculator {...props} href={routePaths.main.products.request} />
    </motion.div>
  );
}

const StyledTitle = styled(Typography)`
  margin-bottom: 1.8rem;

  @media screen and (max-width: ${(props) => props.theme.sizes.tablet}) {
    margin-bottom: 2rem;
  }
`;
